import { IconAccessSmall } from '@components/icons/access-small';
import { IconAppSmall } from '@components/icons/app-small';
import { IconApplicationSmall } from '@components/icons/application-small';
import { IconFilesSmall } from '@components/icons/files-small';
import { IconJourney } from '@components/icons/journey';
import { IconMessagesSmall } from '@components/icons/messages-small';
import { IconNotesSmall } from '@components/icons/notes-small';
import { IconRatingSmall } from '@components/icons/rating-small';
import { useIsMobile } from '@hooks/use-is-mobile';

import { useFeature } from 'features/authentication/authentication-queries';
import { useStore } from 'models/Provider';

export const useApplicationTabs = (application) => {
  const { t } = useStore();
  const isMobile = useIsMobile();
  const hasJourneysIntegration = useFeature('FEATURE_INTEGRATION_JOURNEYS');
  const useMessages = application.job.useMessages;
  const linkRoot = `/jobs/${application.job.id}/application/${application.id}/`;

  const items = [
    {
      display: t('application.tabs.details'),
      icon: isMobile ? undefined : <IconApplicationSmall />,
      value: 'details',
      link: linkRoot + 'details',
    },
    {
      display: t('application.tabs.notes'),
      icon: isMobile ? undefined : <IconNotesSmall />,
      value: 'notes',
      count: application.numNotes,
      activeCount: application.userRead && !application.userRead.notes,
      link: linkRoot + 'notes',
    },
    {
      display: t('application.tabs.ratings'),
      icon: isMobile ? undefined : <IconRatingSmall />,
      value: 'ratings',
      count: application.numReviews,
      activeCount: application.userRead && !application.userRead.ratings,
      link: linkRoot + 'ratings',
    },
    {
      display: t('application.tabs.files'),
      icon: isMobile ? undefined : <IconFilesSmall />,
      value: 'files',
      count: application.numAttachments,
      activeCount: application.userRead && !application.userRead.files,
      link: linkRoot + 'files',
    },
    ...(hasJourneysIntegration
      ? [
          {
            display: t('application.tabs.journeys'),
            icon: isMobile ? undefined : <IconJourney size={12} />,
            value: 'journeys',
            link: linkRoot + 'journeys',
          },
        ]
      : []),
    {
      display: t('application.tabs.apps'),
      icon: isMobile ? undefined : <IconAppSmall />,
      value: 'apps',
      link: linkRoot + 'apps',
    },
    {
      display: t('application.tabs.access'),
      icon: isMobile ? undefined : <IconAccessSmall />,
      value: 'access',
      link: linkRoot + 'access',
    },
  ];

  if (useMessages) {
    items.splice(4, 0, {
      display: t('application.tabs.messages'),
      icon: isMobile ? undefined : <IconMessagesSmall />,
      count: application.numMessages,
      value: 'messages',
      activeCount: application.userRead && !application.userRead.messages,
      error: application.userRead?.messagesFailed === false,
      link: linkRoot + 'messages',
    });
  }
  return items;
};
